import { doPost, doGet, doPut, doDelete } from "../base";

const CLIENTS_URL = (clientId = "", parentId = "", type = null) => `/user_auth/clients${clientId !== "" ? `/${clientId}` : ""}?${type ? `type=${type}` : ''}${parentId && parentId!== "" ? `&parentId=${parentId}` : ''}`;
const ASSIGN_URL  = "/user_auth/assign-user";
const SETTINGS_URL  = "/user_auth/clients/settings";

const SET_DAFAULTS = ({ limit, offset, sort }) => {
    let params = [];
    if (limit && limit !== null) {
        params.push("limit=" + limit);
    }
    if (offset && offset !== null) {
        params.push("offset=" + offset);
    }
    if (sort && sort !== null) {
        params.push("sort=" + sort);
    }

    return params;
}

export const getClients = async ({ clientId = "", parentId = "", type="FACILITY", limit, offset, sort, retrieveAll }) => {
    
    var url;

    if(retrieveAll){
       url =  `${CLIENTS_URL("", "", type)}${type || parentId?'&shouldFindAll=true': 'shouldFindAll=true'}`;
    }else{
        url = CLIENTS_URL(clientId, parentId, type)
    }
    

    let params = SET_DAFAULTS({limit, offset, sort});
    for (let i=0; i < params.length; i++) {
        url += i > 0 ? "&" + params[i] : "?" + params[i];
    }

    return await doGet(url).catch((error) => {
        // TODO CHECK STATUS AND ERROR CODE.
        throw error;
    });
};

export const getSettings = async () => {
    var url = SETTINGS_URL;
    return await doGet(url).catch((error) => {
        // TODO CHECK STATUS AND ERROR CODE.
        throw error;
    });
};

export const postClient = async ({ client , type = "FACILITY"}) => {
    const { name, parentId, contacts, settings, pharmacyId } = client
    const payload = checkClientPayload(name, type, parentId, contacts, settings, pharmacyId);

    return await doPost(payload, CLIENTS_URL()).catch((error) => {
        // TODO CHECK STATUS AND ERROR CODE.
        throw error;
    })
}

export const putClient = async ({ client }) => {
    const { clientId, name, parentId, contacts, settings } = client
    const payload = checkClientPayloadForUpdate(clientId, name, parentId, contacts, settings);

    if (!clientId) {
        throw new Error("clientId cannot be null");
    }
    var url = CLIENTS_URL(clientId);
    
    return await doPut(payload, url).catch((error) => {
        // TODO CHECK STATUS AND ERROR CODE.
        throw error;
    })
}

export const deleteClient = async (clientId) => {
    if (!clientId) {
        throw new Error("clientId cannot be null");
    }
    var url = CLIENTS_URL(clientId);

    return await doDelete(url).catch((error) => {
        // TODO CHECK STATUS AND ERROR CODE.
        throw error;
    })
}

const checkClientPayload = (name, type, parentId, contacts, settings, pharmacyId) => {
    if (!name || name === null) {
        throw new Error("name cannot be null");
    }

    const payload = {
        name,
        type,
        parentId,
        contacts,
        settings,
        pharmacyId
    };

    return payload;
}

const checkClientPayloadForUpdate = (clientId, name, parentId, contacts, settings) => {
    if (!name || name === null) {
        throw new Error("title cannot be null");
    }
    let payload = {};

    if ((parentId === null)) {
        payload = {
            name,
            contacts,
            settings
        };
    } else {
        payload = {
            name,
            parentId,
            contacts,
            settings
        };
    }

    return payload;
}

export const getClient = async (clientId, {limit, offset, sort}) => {

    if (!clientId || clientId === null) {
        throw new Error("clientId cannot be null.");
    }

    var url = CLIENTS_URL(clientId);
    let params = SET_DAFAULTS({limit, offset, sort});

    for (let i=0; i < params.length; i++) {
        url += i > 0 ? "&" + params[i] : "?" + params[i];
    }

    return await doGet(url).catch((error) => {
        // TODO CHECK STATUS AND ERROR CODE.
        throw error;
    });
};

export const assignToUser = async (clientId, { assignIds, unassignIds }) => {

    const payload = {};

    if (assignIds && assignIds.length > 0) {
        payload.assignIds = assignIds;
    }

    if (unassignIds && unassignIds.length > 0) {
        payload.unassignIds = unassignIds;
    }

    return await doPost(payload, ASSIGN_URL(clientId)).catch((error) => {
        // TODO CHECK STATUS AND ERROR CODE.
        throw error;
    })
};

export const fetchUnassignedPharmacies = async () => {
    let url = CLIENTS_URL("pharmacies/unassigned");

    return await doGet(url).catch((error) => {
        throw error;
    });
};
